import { axiosKK } from './networkRequest';
import { AdminPartner, AdminPartnerType } from '../components/admin/CreatePartnerModal';

/**
 * The partners table, as `GET /admin/partners` serves it: active and not deleted.
 *
 * Every admin partner dropdown reads this. Until 2026-10-16 the Logistics
 * picker, the "Create logistics user" modal and the Assign modal each built
 * their list out of partner *users* instead — so a partner added on the
 * Partners screen, which has no users yet, appeared in none of them, and could
 * never be given its first user either, because that form's partner list had
 * the same blind spot.
 */
export function fetchAdminPartners(): Promise<AdminPartner[]> {
  return axiosKK
    .get<{ partners: AdminPartner[] }>('/admin/partners')
    .then(({ data }) => byName(data.partners || []));
}

export function byName<T extends { name: string }>(list: T[]): T[] {
  return [...list].sort((a, b) => a.name.localeCompare(b.name));
}

/** A partner that runs collections and deliveries — the work an order's partner and couriers do. */
export function isCourierPartner(partner: { type?: AdminPartnerType | string }): boolean {
  return partner.type === 'COURIER' || partner.type === 'BOTH';
}

/** A partner that keeps boxes — the kind that needs warehouse locations. */
export function isWarehousePartner(partner: { type?: AdminPartnerType | string }): boolean {
  return partner.type === 'WAREHOUSE' || partner.type === 'BOTH';
}
